import { put, call } from 'redux-saga/effects';
import {
  setStartLoading,
  setEndLoading,
} from '../common/redux/loadManager/actions';
import { getLoadId } from '../common/redux/loadManager/methods';

export default function* withLoading(saga, ...args) {
  const loadId = getLoadId();
  yield put(setStartLoading(loadId));
  try {
    const result = yield call(saga, ...args);

    if (Array.isArray(result)) {
      for (const effect of result) {
        yield effect;
      }
    }

    yield put(setEndLoading(loadId));
    return result;
  } catch (error) {
    yield put(setEndLoading(loadId));
    throw error;
  }
}
